import useGlobalQueries from './useGlobalQueries';
import useIsLabFeatureEnabled from './useIsLabFeatureEnabled';
import usePermissionsAccess from './usePermissionsAccess';

export default () => {
  const isLabFeatureEnabled = useIsLabFeatureEnabled('letters');
  const access = usePermissionsAccess(isLabFeatureEnabled && 'Letter');
  const { adminSettings, currentUser } = useGlobalQueries();

  if (access.isUnrestrictedAdmin) return { hasCreateLetterAccess: true, hasSendLetterAccess: true };
  if (!adminSettings.isSuccess) return { hasCreateLetterAccess: false, hasSendLetterAccess: false };

  const value = isLabFeatureEnabled ? access.access : currentUser.data?.roles?.letter;
  const isNotOff = Boolean(value && value !== 'off');

  const hasCreateLetterAccess = isLabFeatureEnabled
    ? value === 'edit' && access.enforcementRule === 'all'
    : isNotOff;

  const hasSendLetterAccess = hasCreateLetterAccess || (isLabFeatureEnabled && isNotOff);

  return { hasCreateLetterAccess, hasSendLetterAccess };
};
